(function ($) {
	if ($(".js-modal-video").length) {
		$(".js-modal-video").modalVideo({
			channel: "youtube",
			youtube: {
				controls: 1, // コントロール表示（0は非表示）
			},
		});
	}

	$(window).on('load', function () {
		$('.headerNavi').removeClass('preload');
	});
})(jQuery);

const jobs = document.querySelectorAll('.js-job');

function tabChangeListener() {
	document.querySelectorAll('input[name="tabset"]').forEach(function (radio) {
		radio.addEventListener('change', function () {
			jobs.forEach(function (div) {
				div.classList.remove("is-active");
			});

			const target = document.getElementById(radio.value);
			if (target) {
				target.classList.add("is-active");
			}
		});
	});
}

function tabToggle() {
	const PC = window.matchMedia("(min-width: 480px)").matches;

	if (PC) {
		document.querySelector('input[name="tabset"]:checked').dispatchEvent(new Event('change'));
	} else {
		jobs.forEach(function (div) {
			div.classList.remove("is-active");
		});
	}
}

//タブのイベント登録を実行
tabChangeListener();

tabToggle();
window.addEventListener('resize', tabToggle);


